import React from "react";
import { Helmet } from "react-helmet";

const CommitteeMemberChairman = () => {
  return (
    <div>
      <Helmet>
        <title>Committee Member Chairman | Nandan Denim Ltd .</title>
      </Helmet>
    </div>
  )
};

export default CommitteeMemberChairman;
